// import { useEffect, useState, useRef } from "react"
// import { Link } from "react-router-dom"
// import { getServiceCategories } from "../../../services/servicesModuleApi"
// import { useServiceContext } from "../../../context/ServiceContext"

// const ServicesSection = () => {
//   const [categories, setCategories] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)
//   const [currentPage, setCurrentPage] = useState(0)
//   const { setSelectedCategory } = useServiceContext()
//   const fetchedRef = useRef(false)

//   const ITEMS_PER_PAGE = 18 // 3 rows of 6 items

//   useEffect(() => {
//     // Prevent multiple fetches
//     if (fetchedRef.current) return

//     const fetchCategories = async () => {
//       try {
//         setLoading(true)
//         const response = await getServiceCategories()

//         // Correctly access the nested data structure
//         if (response.success && response.data && response.data.data) {
//           setCategories(response.data.data)
//         } else {
//           setError("Failed to fetch service categories")
//           console.error("Invalid data format:", response)
//         }
//       } catch (err) {
//         setError("An unexpected error occurred")
//         console.error(err)
//       } finally {
//         setLoading(false)
//         fetchedRef.current = true
//       }
//     }

//     fetchCategories()
//   }, []) // Empty dependency array to run only once

//   const handleCategoryClick = (category) => {
//     setSelectedCategory(category)
//   }

//   if (loading) {
//     return (
//       <section className="py-16">
//         <div className="container mx-auto px-4 text-center">
//           <div className="text-center mb-12">
//             <h2 className="text-5xl font-bold mb-3 text-[#005b9f]">Services</h2>
//             <p className="text-gray-800 text-lg">Loading service categories...</p>
//           </div>
//         </div>
//       </section>
//     )
//   }

//   if (error) {
//     return (
//       <section className="py-16">
//         <div className="container mx-auto px-4 text-center">
//           <div className="text-center mb-12">
//             <h2 className="text-5xl font-bold mb-3 text-[#005b9f]">Services</h2>
//             <p className="text-red-500 text-lg">Error: {error}</p>
//           </div>
//         </div>
//       </section>
//     )
//   }

//   // Calculate total pages
//   const totalPages = Math.ceil(categories.length / ITEMS_PER_PAGE)

//   // Get current page items
//   const currentItems = categories.slice(currentPage * ITEMS_PER_PAGE, (currentPage + 1) * ITEMS_PER_PAGE)

//   // Chunk current items into rows of 6
//   const rows = []
//   for (let i = 0; i < currentItems.length; i += 6) {
//     rows.push(currentItems.slice(i, i + 6))
//   }

//   return (
//     <section className="py-16">
//       <div className="container mx-auto px-4 text-center">
//         <div className="text-center mb-12">
//           <h2 className="text-5xl font-bold mb-3 text-[#005b9f]">Services</h2>
//           <p className="text-gray-800 text-lg">Check out our wide range of services</p>
//         </div>

//         {/* Render each row of services */}
//         {rows?.map((row, rowIndex) => (
//           <div
//             key={`row-${rowIndex}`}
//             className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6 max-w-5xl mx-auto mb-12"
//           >
//             {row?.map((category) => (
//               <Link
//                 key={category?._id}
//                 to={`/services/${category?._id}`}
//                 className="group"
//                 onClick={() => handleCategoryClick(category)}
//               >
//                 <div className="flex flex-col items-center">
//                   <div className="mb-3 flex h-20 w-20 items-center justify-center rounded-full bg-[#e1f5fe] group-hover:bg-[#c8e4fa] transition-colors">
//                     <img src={`${category?.icon}`} alt={category?.name} className="h-10 w-10" />
//                   </div>
//                   <span className="text-base font-bold text-gray-900">{category.name}</span>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         ))}

//         {/* Pagination */}
//         {totalPages > 1 && (
//           <div className="flex justify-center items-center mt-8 space-x-2">
//             {Array.from({ length: totalPages }).map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => setCurrentPage(index)}
//                 className={`w-8 h-1 rounded-full transition-colors ${
//                   currentPage === index ? "bg-[#005b9f]" : "bg-gray-300 hover:bg-gray-400"
//                 }`}
//                 aria-label={`Page ${index + 1}`}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   )
// }

// export default ServicesSection

// new code for ServicesSection.jsx

// ==============================
// ServicesSection.jsx
// (unchanged behavior, kept complete)
// ==============================

// ==============================
// ==============================
// ServicesSection.jsx  (UNCHANGED)
// ==============================
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { getServiceCategories } from "../../../services/services-module-api";
import { useServiceContext } from "../../../context/service-context";

const ServicesSection = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const { setSelectedCategory } = useServiceContext();
  const fetchedRef = useRef(false);

  const ITEMS_PER_PAGE = 18;

  useEffect(() => {
    if (fetchedRef.current) return;

    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await getServiceCategories();

        if (response?.success && response?.data?.data) {
          setCategories(response.data.data);
        } else {
          setError("Failed to fetch service categories");
          console.error("Invalid data format:", response);
        }
      } catch (err) {
        setError("An unexpected error occurred");
        console.error(err);
      } finally {
        setLoading(false);
        fetchedRef.current = true;
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (category) => setSelectedCategory(category);

  if (loading) {
    return (
      <section className="py-16">
        <div className="container mx-auto px-4 text-center">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold mb-3 text-[#005b9f]">Services</h2>
            <p className="text-gray-800 text-lg">
              Loading service categories...
            </p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-16">
        <div className="container mx-auto px-4 text-center">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold mb-3 text-[#005b9f]">Services</h2>
            <p className="text-red-500 text-lg">Error: {error}</p>
          </div>
        </div>
      </section>
    );
  }

  const totalPages = Math.ceil(categories.length / ITEMS_PER_PAGE);
  const currentItems = categories.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE,
  );

  const rows = [];
  for (let i = 0; i < currentItems.length; i += 6)
    rows.push(currentItems.slice(i, i + 6));

  return (
    <section className="py-16">
      <div className="container mx-auto px-4 text-center">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold mb-3 text-[#005b9f]">Services</h2>
          <p className="text-gray-800 text-lg">
            Check out our wide range of services
          </p>
        </div>

        {rows?.map((row, rowIndex) => (
          <div
            key={`row-${rowIndex}`}
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6 max-w-5xl mx-auto mb-12"
          >
            {row?.map((category) => (
              <Link
                key={category?._id}
                to={`/services/${category?._id}`}
                className="group"
                onClick={() => handleCategoryClick(category)}
              >
                <div className="flex flex-col items-center">
                  <div className="mb-3 flex h-20 w-20 items-center justify-center rounded-full bg-[#e1f5fe] group-hover:bg-[#c8e4fa] transition-colors">
                    <img
                      src={`${category?.icon}`}
                      alt={category?.name}
                      className="h-10 w-10"
                    />
                  </div>
                  <span className="text-base font-bold text-gray-900">
                    {category?.name}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        ))}

        {totalPages > 1 && (
          <div className="flex justify-center items-center mt-8 space-x-2">
            {Array.from({ length: totalPages }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentPage(index)}
                className={`w-8 h-1 rounded-full transition-colors ${
                  currentPage === index
                    ? "bg-[#005b9f]"
                    : "bg-gray-300 hover:bg-gray-400"
                }`}
                aria-label={`Page ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ServicesSection;
